import { FC, useRef } from 'react';

import clsx from 'clsx';

import { IViewProps } from './types';

import styles from './SectionsNavigationItem.module.scss';

/** TODO WIP support the submenu! At the moment in doesn't work for plans where sections have submenus */
export const MobileView: FC<IViewProps> = ({ icon, isSectionActive, label, isDisabled, onSectionClick }) => {
  const activeItemRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={activeItemRef}
      onClick={onSectionClick}
      className={clsx(styles['tab_mobile'], {
        [styles['tab_mobile__active']]: isSectionActive,
        [styles['tab_mobile__disabled']]: isDisabled,
      })}
    >
      {label}
      {isDisabled && icon}
    </div>
  );
};
